<template>
	<div class="watch-options-delete">
		<p>Remove patient?</p>
		<button-icon-text-loading @click.native="deletePatient" icon="check">{{ $t('buttons.general.delete') }}</button-icon-text-loading>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			name: 'watch options delete',
		}
	},
	methods: {
		deletePatient () {
			if (confirm('Delete?')) {
				console.log('deletePatient unimplemented')
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/options/WatchOptionsDelete.vue